import _styled from "@emotion/styled/base";
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
import { css } from '@emotion/react';
import { colors, getResetByTag, rem, utilityStyles } from '../../../../styles';
import StyledTileDivider from '../../styles/tile.divider.styles';
var defaultStyles = function defaultStyles() {
  return /*#__PURE__*/css("padding:", rem(16), ";flex-grow:1;" + (process.env.NODE_ENV === "production" ? "" : ";label:defaultStyles;"));
};
var densityStyles = function densityStyles(_ref3) {
  var density = _ref3.density;
  if (density === 'compact') {
    return /*#__PURE__*/css("padding:", rem(8, 16), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:densityStyles;"));
  } else {
    return /*#__PURE__*/css("padding:", rem(16), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:densityStyles;"));
  }
};
var _ref2 = process.env.NODE_ENV === "production" ? {
  name: "1hcx8jb",
  styles: "padding:0"
} : {
  name: "16i5xo9-isFlushStyles",
  styles: "padding:0;label:isFlushStyles;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
var isFlushStyles = function isFlushStyles(_ref4) {
  var isFlush = _ref4.isFlush;
  if (isFlush === true) {
    return _ref2;
  }
};
var _ref = process.env.NODE_ENV === "production" ? {
  name: "1t90u8d",
  styles: "box-shadow:none"
} : {
  name: "1lld0nx-variantStyles",
  styles: "box-shadow:none;label:variantStyles;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
var variantStyles = function variantStyles(_ref5) {
  var variant = _ref5.variant;
  switch (variant) {
    case 'dark':
      return /*#__PURE__*/css("color:", colors.white, ";&+", StyledTileDivider, "{background-color:", colors.navy_500, ";>div{border-top-color:", colors.navy_300, ";}}" + (process.env.NODE_ENV === "production" ? "" : ";label:variantStyles;"));
    case 'brand':
      return /*#__PURE__*/css("color:", colors.white, ";&+", StyledTileDivider, "{background-color:", colors.blue_500, ";>div{border-top-color:", colors.blue_400, ";}}" + (process.env.NODE_ENV === "production" ? "" : ";label:variantStyles;"));
    case 'transparent':
      return _ref;
  }
};
var sizeStyles = function sizeStyles(_ref6) {
  var size = _ref6.size;
  switch (size) {
    case 'xs':
      return /*#__PURE__*/css("max-height:", rem(124), ";overflow-y:auto;" + (process.env.NODE_ENV === "production" ? "" : ";label:sizeStyles;"));
    case 'sm':
      return /*#__PURE__*/css("max-height:", rem(256), ";overflow-y:auto;" + (process.env.NODE_ENV === "production" ? "" : ";label:sizeStyles;"));
    case 'md':
      return /*#__PURE__*/css("max-height:", rem(512), ";overflow-y:auto;" + (process.env.NODE_ENV === "production" ? "" : ";label:sizeStyles;"));
    case 'lg':
      return /*#__PURE__*/css("max-height:", rem(768), ";overflow-y:auto;" + (process.env.NODE_ENV === "production" ? "" : ";label:sizeStyles;"));
    case 'xl':
      return /*#__PURE__*/css("max-height:", rem(1024), ";overflow-y:auto;" + (process.env.NODE_ENV === "production" ? "" : ";label:sizeStyles;"));
  }
};
var resetStyles = getResetByTag('div');
var StyledTileBody = /*#__PURE__*/_styled('div', process.env.NODE_ENV === "production" ? {
  target: "eii7w930"
} : {
  target: "eii7w930",
  label: "StyledTileBody"
})(resetStyles, defaultStyles, densityStyles, isFlushStyles, variantStyles, sizeStyles, utilityStyles);
export default StyledTileBody;